module.exports = __webpack_public_path__ + "static/Singha_Resume-ed39000d71a534cae8372176c8ab6662.pdf";